module.exports = __webpack_public_path__ + "media/images/cleaning/cover-mobile-6994518fbb450b9ea57a3b5a39bf4e2b.jpg";